import "./CountdownEmptyState.css";

type Props = {
  onAdd: () => void;
};

export function CountdownEmptyState({
  onAdd,
}: Props) {
  return (
    <section className="countdown-empty-state">
      <span aria-hidden="true">⌛</span>

      <h2>Your next moment starts here</h2>

      <p>
        Create a live countdown for a journey,
        birthday or important event.
      </p>

      <button type="button" onClick={onAdd}>
        Create countdown
      </button>
    </section>
  );
}